module.exports = __webpack_public_path__ + "static/img/Bottom frame@3x.dc60786.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Bottom frame@3x.png
// module id = KRQ2
// module chunks = 1